import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Login from "../pages/login";
import Dashboard from "../pages/dashboard";

const AppRouter = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "/dashboard",
      element: <Dashboard />,
    },
  ]);

  return <RouterProvider router={router} />;
};

export default AppRouter;
